export const rfidUsersResource = {
  name: 'RFID 用戶',
  fields: {
    id: 'ID',
    vendorId: '商戶',
    vendorName: '商戶名稱',
    firstName: '名字',
    lastName: '姓氏',
    displayName: '顯示名稱',
    email: '電郵',
    phone: '電話',
    isActive: '啟用',
    createdAt: '創建時間',
    updatedAt: '更新時間',
  },
  sections: {
    basicInfo: '基本資料',
    settings: '設置',
  },
  list: {
    subtitle: '管理無應用程式訪問權限的純 RFID 用戶',
  },
  create: {
    title: '創建 RFID 用戶',
    subtitle: '註冊新的純 RFID 用戶',
    infoMessage: 'RFID 用戶適用於需要充電訪問權限但無需使用移動應用程式的員工或承包商。',
    vendorHelperText: '選擇此用戶所屬的商戶/公司',
    displayNameHelperText: '此名稱將顯示在充電時段和報告中',
    emailHelperText: '選填 - 用於通知和收據',
    phoneHelperText: '選填 - 用於短信通知',
    cardInfo: 'RFID 卡片分配',
    cardHelperText: '創建後可通過 RFID 卡片管理頁面為此用戶分配 RFID 卡片。',
  },
  edit: {
    title: '編輯 RFID 用戶',
    subtitle: '更新 RFID 用戶資訊',
    vendorHelperText: '選擇此用戶所屬的商戶/公司',
    displayNameHelperText: '此名稱將顯示在充電時段和報告中',
    emailHelperText: '選填 - 用於通知和收據',
    phoneHelperText: '選填 - 用於短信通知',
  },
  show: {
    subtitle: '檢視 RFID 用戶詳情',
  },
  notifications: {
    created: '已創建 RFID 用戶',
    updated: '已更新 RFID 用戶',
  },
  groupsPanel: {
    title: '群組',
    empty: '未加入任何群組',
    selectPlaceholder: '選擇群組...',
    noOptions: '找不到群組',
    noGroupsExist: '目前尚未建立任何用戶群組。',
    manageGroups: '管理用戶群組',
    save: '儲存群組',
    saved: '群組已儲存',
  },
};

export const rfidUsers = {
  'rfid-users': rfidUsersResource,
};